/**
 * 점유 항목 꼬리의 갱신 시각 — 서버 `preflight._occupied_blockers` 가 `local_stamp(updated_at, '%m-%d %H:%M:%S')`(KST · core `bfc8d2ca`)로 붙인다.
 * 🔴 실측 2026-10-29 `centrifuge.grip_tray_on_holder (근거 confirmed · 10-29 08:53:14 갱신)` — RFC 3339 만 받던 때 이 꼬리를 못 읽어
 *    [자리 정리] 가 「서버가 자리 식별자를 제공하지 않아…」로 전부 꺼졌다. `local_stamp` 는 못 읽은 값을 원문으로 두므로 RFC 3339 도 같이 받는다
 */
const UPDATED_AT = String.raw`(?:\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})|\d{2}-\d{2} \d{2}:\d{2}:\d{2}) 갱신`
const OCCUPIED_ITEM = new RegExp(
  `^([^\\s()·]+)(?: \\(근거 [^\\s()·]+(?: · ${UPDATED_AT})?\\)| \\(${UPDATED_AT}\\))?$`,
)

export function resolveHandoffPoint(
  item: string | null,
  pointIds: readonly string[],
): string | null {
  if (item === null) return null
  const pointId = OCCUPIED_ITEM.exec(item)?.[1]
  return pointId !== undefined && pointIds.includes(pointId) ? pointId : null
}

export function handoffPointIds(occupancy: unknown): string[] {
  if (!Array.isArray(occupancy)) return []
  return occupancy.flatMap((entry: unknown) => {
    if (typeof entry !== 'object' || entry === null) return []
    const pointId = (entry as { point_id?: unknown }).point_id
    return typeof pointId === 'string' ? [pointId] : []
  })
}
